import BaseView from "../../../vendor_core/core/src/views/BaseView";


class CustomReelFrame extends BaseView
{


    constructor()
    {
        super();

        let parts = ["left", "right", "top", "bottom"];

        for (let partIdx=0; partIdx < parts.length; partIdx++)
        {
            let partSprite = this.assets.getSprite(parts[partIdx]);
            this.addChild(partSprite);
            // this.layout.setHeight(partSprite, 71.3);
            partSprite.x = this.layout.relWidth(16.3);
            partSprite.y = this.layout.relHeight(8.2);
        }
    }


}

export default CustomReelFrame
